import React from 'react'
import { Box, Skeleton, Typography } from '@mui/material'
import { UnitTypes } from 'src/Libs/types'

interface Props {
  stateOfCharge?: number
  vehicleImageUrl: string | null
  isVehicleImageLoading: boolean
}

/**
 * Component to display vehicle information and vehicle image.
 */
const VehicleWidgetInformation: React.FC<Props> = ({ stateOfCharge, vehicleImageUrl, isVehicleImageLoading }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Typography variant="h1">
        {stateOfCharge ?? '-'}
        <Typography variant="h2" component="span">{` ${UnitTypes.percentage}`}</Typography>
      </Typography>

      {vehicleImageUrl && (
        <Box
          component="img"
          src={vehicleImageUrl}
          alt="vehicle-widget-image"
          sx={{
            maxWidth: '50%',
            display: isVehicleImageLoading ? 'none' : 'block',
            aspectRatio: '16 / 9',
            objectFit: 'cover',
            borderRadius: 1,
          }}
        />
      )}

      {isVehicleImageLoading && <Skeleton variant="rounded" height={'50px'} width={'50%'} sx={{ position: 'relative', top: 0, right: 0 }} />}
    </Box>
  )
}

export default VehicleWidgetInformation
